import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Btn } from '../components/shared/UI';
import LanguageSwitcher from '../components/shared/LanguageSwitcher';
import { useT } from '../i18n';
import api from '../utils/api';

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { t } = useT();
  const [state, setState] = useState({ status: 'loading', message: '' });

  useEffect(() => {
    const token = params.get('token');
    if (!token) {
      setState({ status: 'error', message: '' });
      return;
    }
    // Same page confirms a first-time verification and an email CHANGE — the
    // link carries mode=email-change for the latter.
    const endpoint = params.get('mode') === 'email-change' ? '/auth/email-change/confirm' : '/auth/verify-email';
    api.get(`${endpoint}?token=${encodeURIComponent(token)}`)
      .then(r => setState({ status: 'success', email: r.data.email }))
      .catch(e => setState({ status: 'error', message: e.response?.data?.message || '' }));
  }, [params]);

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: 24, background: 'linear-gradient(135deg, #0f2447 0%, #1A3C6E 50%, #2E75B6 100%)',
      fontFamily: 'inherit', position: 'relative',
    }}>
      <div style={{ position: 'absolute', top: 20, insetInlineEnd: 20 }}>
        <LanguageSwitcher variant="dark" compact />
      </div>

      <div style={{
        width: '100%', maxWidth: 460, background: 'var(--card-bg)', borderRadius: 16,
        padding: '40px 36px', boxShadow: '0 24px 60px rgba(0,0,0,0.3)', textAlign: 'center',
      }}>
        <div style={{ marginBottom: 16 }}>
          <span style={{ fontSize: 36, fontWeight: 900, color: '#F59E0B', letterSpacing: '-2px' }}>I</span>
          <span style={{ fontSize: 36, fontWeight: 700, color: 'var(--heading)', letterSpacing: '-1.5px' }}>nvio</span>
        </div>

        {state.status === 'loading' && (
          <>
            <div style={{ fontSize: 36, marginBottom: 12 }}>⏳</div>
            <h2 style={{ fontSize: 18, fontWeight: 700, color: 'var(--text)', marginBottom: 8 }}>{t('verify.verifying')}</h2>
            <p style={{ fontSize: 13, color: 'var(--text-muted)' }}>{t('verify.justAMoment')}</p>
          </>
        )}

        {state.status === 'success' && (
          <>
            <div style={{ fontSize: 48, marginBottom: 12 }}>✅</div>
            <h2 style={{ fontSize: 20, fontWeight: 700, color: 'var(--heading)', marginBottom: 8 }}>{t('verify.verified')}</h2>
            <p style={{ fontSize: 14, color: 'var(--text-muted)', marginBottom: 24 }}>
              <b style={{ color: 'var(--text)' }}>{state.email}</b> {t('verify.confirmed')}
            </p>
            <Btn variant="primary" onClick={() => navigate('/')} style={{ width: '100%', justifyContent: 'center' }}>
              {t('verify.continue')}
            </Btn>
          </>
        )}

        {state.status === 'error' && (
          <>
            <div style={{ fontSize: 48, marginBottom: 12 }}>⚠️</div>
            <h2 style={{ fontSize: 20, fontWeight: 700, color: 'var(--danger)', marginBottom: 8 }}>{t('verify.failed')}</h2>
            <p style={{ fontSize: 14, color: 'var(--text-muted)', marginBottom: 24 }}>{state.message || t('verify.failedGeneric')}</p>
            <Btn variant="ghost" onClick={() => navigate('/login')} style={{ width: '100%', justifyContent: 'center' }}>
              {t('auth.backToSignInBtn')}
            </Btn>
            <p style={{ fontSize: 12, color: 'var(--text-subtle)', marginTop: 16 }}>
              {t('verify.alreadySignedIn')}
            </p>
          </>
        )}
      </div>
    </div>
  );
}
